<template>
  <!-- 账单查询 -->
  <div class="page-container" id="ebOrderContainer">
    <el-form :model="searchData" ref="ruleFormRef" class="form-panel" label-position="top"
             :validateOnRuleChange="false">
      <el-row class="content-panel">
        <el-row :gutter="22">
          <el-row :gutter="10" style="margin: 5px">
            <el-col :span="5">
              <el-form-item label="账单号">
                <el-input size="mini" v-model="searchData.compNo" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="币别">
                <el-select size="mini" v-model="searchData.currencyCode" placeholder="请选择币别" clearable>
                  <el-option
                    v-for="item in currencyCodeOptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="提单号:">
                <el-input size="mini" v-model="searchData.mblNo" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="客户业务号:">
                <el-input size="mini" v-model="searchData.custBizNo" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="账单状态:">
                <el-select size="mini" v-model="searchData.confirmStatus" placeholder="请选择账单状态">
                  <el-option
                    v-for="item in confirmStatusOptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin: 5px">
            <el-col :span="5">
              <el-form-item label="船公司:">

                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_carrier"
                  :query-method="associate_queryMethod_carrier"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="custAlias"
                  value-prop="custNameCn"
                  placeholder=""
                  v-model="searchData.carrierName"
                  size="mini"
                  @change="onChangeCarrier"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="船名/航次:">
                    <el-associate
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="vesselName"
                      value-prop="mdVoyagePlanId"
                      placeholder=""
                      v-model="searchData.vesselName"
                      size="mini"
                      @change="onChangeVessel"
                      case="upper"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-input
                      size="mini"
                      placeholder=""
                      clearable
                      v-model="searchData.voyage"
                    >
                    </el-input>
<!--                    <el-associate
                      style="width: 100%"
                      :columns="associate_columns_voyage"
                      :query-method="associate_queryMethod_voyage"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="voyage"
                      value-prop="voyage"
                      placeholder=""
                      v-model="searchData.voyage"
                      size="mini"
                      name="voyage"
                      case="upper"
                    />-->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="4">
              <el-form-item label="开航日期从:">
                <el-date-picker
                  v-model="searchData.etdFrom"
                  align="right"
                  type="date"
                  style="width: 100%"
                  size="mini"
                  placeholder=""
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="开航日期到:">
                <el-date-picker
                  v-model="searchData.etdTo"
                  align="right"
                  type="date"
                  style="width: 100%"
                  size="mini"
                  placeholder=""
                  :picker-options="pickerOptions"
                  @change="changeEndEtd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5" style="padding-top: 17px">
                <el-button class="el-button-search" type="primary" size="small" plain @click="queryForm">查询</el-button>
                <el-button type="primary" size="small" plain @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-row>
        <!-- </div> -->
        <!-- 表格-start -->
        <el-row style="margin-top: 15px">
          <hot-table ref="ebOrderTableRef" :data-source="billTableDataSource"
                     :settings="billTableSettings" col-settings-key="bill" @rowDblclick="toBillDetails">
            <hot-column :has-tip="true" data="compNo" title="账单号" width="150"></hot-column>
            <hot-column :has-tip="true" data="settleCustName" title="结算单位" width="150"></hot-column>
            <hot-column :has-tip="true" data="settleOfficeName" title="结算公司" width="150"></hot-column>
            <hot-column :has-tip="true" data="currencyCode" title="币种" width="150"></hot-column>
            <hot-column :has-tip="true" data="amount" title="金额" width="150"></hot-column>
            <hot-column :has-tip="true" data="creatorName" title="制单人" width="150"></hot-column>
            <hot-column :has-tip="true" data="confirmStatus" title="账单状态" width="150"></hot-column>
            <hot-column :has-tip="true" data="createTime" title="生成日期" width="150" date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
            <hot-column :has-tip="true" data="vesselName" title="船名" width="150"></hot-column>
            <hot-column :has-tip="true" data="voyage" title="航次" width="150"></hot-column>
            <hot-column :has-tip="true" data="carrierName" title="舱位公司" width="150"></hot-column>
            <hot-column :has-tip="true" data="remark" title="备注" width="150"></hot-column>
          </hot-table>
        </el-row>
        <!-- 分页start -->
        <div class="pg_div">
          <el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
                         :page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
                         @current-change="handleCurrentChange" @size-change="handleSizeChange"/>
        </div>
        <!-- 分页end -->
        <!-- 表格-end -->
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { queryBill } from "@/api/queryMainSystem";
import { queryCarrierInfo, queryDictRows, queryPoInfo, queryVoyageInfo } from "@/api/commonService";

export default {
  name: 'Bill',
  data() {
    return {
      //日期设置
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      confirmStatusOptions: [],
      currencyCodeOptions: [],
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "id",
          field: "csCustId",
        },
        {
          title: "中文简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      // 航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      // 装/卸货港联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      bill: {
        compNo: null,
        settleCustName: null,
        settleOfficeName: null,
        currencyCode: null,
        amount: null,
        creatorName: null,
        confirmStatus: null,
        createTime: null,
        vesselName: null,
        voyage: null,
        carrierName: null,
        remark: null
      },
      searchData: {
        compNo: null,
        mblNo: null,
        custBizNo: null,
        currencyCode: null,
        confirmStatus: null,
        carrierId: null,
        vesselId: null,
        voyage: null,
        etdFrom: null,
        etdTo: null,
        isDetail: null
      },

      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },

      // 表格校验
      ebOrderRules: {},
      // 表格数据
      billTableDataSource: [],
      // 表格设置
      billTableSettings: {
        height: 360,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig
      },

    };
  },
  computed: {
    // compNoComputed: {
    //   get: function(){
    //     return this.searchData.compNo;
    //   },
    //   set: function(val){
    //     this.searchData.compNo = val.toUpperCase();
    //   }
    // },
    // mblNoComputed: {
    //   get: function(){
    //     return this.searchData.mblNo;
    //   },
    //   set: function(val){
    //     this.searchData.mblNo = val.toUpperCase();
    //   }
    // },
    // custBizNoComputed: {
    //   get: function(){
    //     return this.searchData.custBizNo;
    //   },
    //   set: function(val){
    //     this.searchData.custBizNo = val.toUpperCase();
    //   }
    // },
  },
  async created() {

  },
  mounted() {
    let self = this
    self.getSelectList()
    // 监听外层容器div宽度的变化，做表格自适应
    self.resizeObserver = new ResizeObserver(entries => {
      self.$nextTick(() => {
        self.$refs.ebOrderTableRef.resizeTo(entries[0].target.clientWidth - 32)
      })
    })
    self.resizeObserver.observe(document.getElementById("ebOrderContainer"))
  },
  methods: {
    //点击
    clickModule(e) {

    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage();
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    // 单击行事件
    rowClick(val) {
      let self = this;
      self.currentEbOrder = val.record;
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      self.pageConfig.currentPage = 1;
      this.queryStatusPage();
    },
    queryStatusPage() {
      let self = this;
      self.queryForm();
    },
    //重置搜索框
    resetForm() {
      this.searchData = {}
    },
    //查询
    queryForm() {
      let self = this;
      self.queryButton = 2;
      let num = 0;
      for (let s in self.searchData) {
        if (self.searchData[s] !== null) {
          num++;
        } else {
          delete self.searchData[s];
        }
      }

      if (num === 0) {
        self.$coreMethods.message("warning", "至少输入一个查询条件");
      } else {
        self.searchData.currentPage = self.pageConfig.currentPage;
        self.searchData.pageSize = self.pageConfig.pageSize;
        self.searchData.isDetail = "N";
        queryBill(self.searchData).then((res) => {
          if (res.success) {
            self.billTableDataSource = res.records.records;
            self.billTableDataSource.forEach(function (bill){
              if(bill.confirmStatus==='N'){
                bill.confirmStatus='未确认';
              }
              if(bill.confirmStatus==='Y'){
                bill.confirmStatus='已确认';
              }
            });
            self.pageConfig.total = res.records.totalRecord;
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    // 跳转账单明细
    toBillDetails(val) {
      //直接跳转
      this.$router.push({
        path: '/query/billDetail',
        query: { info: val.record }
      });
      console.log(val.record)
    },
    //获取数据字典
    getSelectList() {
      queryDictRows('MD_CODE_DICT$MD_CURRENCY,MD_CODE_DICT$MD_CODE_BC_CONFIRM_STATUS').then(res => {
        console.log("queryDictRows:", res)
        //币种
        this.currencyCodeOptions = res.MD_CODE_DICT$MD_CURRENCY;
        //账单状态
        this.confirmStatusOptions = res.MD_CODE_DICT$MD_CODE_BC_CONFIRM_STATUS;
      })
    },
    changeEndEtd() {
      let self = this;
      self.searchData.endEtd = new Date(self.searchData.endEtd.getTime() + 1000 * 24 * 3600 - 100)
    },
    changeEndTime() {
      let self = this;
      self.searchData.endTime = new Date(self.searchData.endTime.getTime() + 1000 * 24 * 3600 - 100)
    },
    onChangeCarrier(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.searchData.carrierId = selectedRows.csCustId;
    },
    onChangeVessel(value, selectedRows) {
      console.log(selectedRows);
      this.searchData.vesselName = selectedRows.vesselName;
      this.searchData.vesselId = selectedRows.vesselId;
      this.searchData.voyage = selectedRows.voyage;
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 装/卸货港联想控件数据源
    associate_queryMethod_po({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.confirmStatus",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
  }
};
</script>

<style scoped lang="less">

</style>
